import React from "react";
import { makeStyles } from "@material-ui/core";
import { useHistory } from "react-router";
import "../styles/header-table.scss";
import SearchButton from "./SearchButton";
import { TitleTable } from "./TitleTable";
import { useTranslation } from "react-i18next";

const HeaderTableAllGroup = ({
  expand,
  onExpand,
  onSearch = () => {},
  route,
  search,
  ...props
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div id="header-table-group" className={`AllGroup__header--wrapper`}>
      <div className="AllGroup__header--wrapper-inner">
        <TitleTable
          // don't show tilte when click on info icon
          expand={expand}
          onExpand={onExpand}
        />

        <div
          id="AllGroup__searchBox--isAllGroup"
          className={`AllGroup__header--right isAllGroup`}
        >
          <SearchButton
            valueSearch={search}
            onSearch={(value) => onSearch(value)}
          />
          {/* <div
            className={classes.wrapperButton}
            onClick={(evt) => history.push(route)}
          >
            {t("DMH.VIEW.PGP.RIGHT.TRASH.BACK")}
          </div> */}
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  wrapperButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    backgroundColor: "#ebedef",
    color: "#adaeba",
    marginLeft: 10,
    fontWeight: 500,
    padding: "10px 14px",
    borderRadius: 3,
    transition: "0.3s all ease-in-out",

    "&:hover": {
      backgroundColor: "#e5e5e5",
    },
  },
  drawerWrapper: {
    position: "fixed",
    bottom: 0,
    right: 0,
    backgroundColor: "#fff",
    height: "calc(100% - 126px)",
    width: "300px",
    transform: "translateX(100%)",
    transition: "0.3s all ease-in-out",
    border: "1px solid #dddddd",
    boxShadow: "rgb(0 0 0 / 5%) 0px 1px 10px 0px",
    "&.isCollapsed": {
      transform: "translateX(0)",
    },
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    padding: 18.5,
    fontSize: 21,
  },
  menuItem: { fontWeight: 500 },
  menuText: { "& span": { fontWeight: 400, color: "#666" } },
  menuIcon: { minWidth: 35 },
});

export default HeaderTableAllGroup;
